import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import styled from 'styled-components';

// @ts-expect-error bend url doesn't support types
import sprocketWhite from 'bender-url!../../img/white_sprocket.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogoBackground = styled.div.withConfig({
  displayName: "BuiltOnHubSpotBadge__LogoBackground",
  componentId: "ryvt7n-0"
})(({
  theme
}) => ({
  background: `linear-gradient(to right, #ff5c35 26px, #fff 26px)`,
  minWidth: theme.space['600'],
  minHeight: theme.space['600'],
  alignItems: 'center'
}));
const BuiltOnHubSpotBadge = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    borderColor: "border-core-default",
    borderWidth: "100",
    borderRadius: "100",
    borderStyle: "solid",
    marginInlineEnd: "400",
    overflow: "hidden",
    children: [/*#__PURE__*/_jsx(LogoBackground, {
      children: /*#__PURE__*/_jsx(Image, {
        src: sprocketWhite,
        role: "img",
        blockSize: "24px",
        padding: "100"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      paddingInline: "100",
      paddingBlock: "0",
      borderRadius: "100",
      backgroundColor: "fill-surface-default",
      inlineSize: "max-content",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.removeBrandingBanner.bannerButton"
        })
      })
    })]
  });
};
export default BuiltOnHubSpotBadge;